export default "__VITE_ASSET__83aff1be__"